var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUranus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(8.5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.36728912 4.90105307c1.03553517 2.33342814 2.7417934 3.50014222 5.11877469 3.50014222 2.3769813 0 4.08297571-1.16739323 5.11798323-3.50217969",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0 -1 1 0 -4.899015 8.401195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.63271088 4.90105307c1.03553517 2.33342814 2.7417934 3.50014222 5.11877472 3.50014222 2.3769813 0 4.0829757-1.16739323 5.1179832-3.50217969",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0 -1 -1 0 17.401195 17.401195)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.251813,
    cy: 18.154355,
    r: 5.299312
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.29593082 0-.08823529 12.3087095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.75181317 6.23304831h-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUranus);
export default __webpack_public_path__ + "static/media/uranus.98604340991925a680e2d5fcdf75df79.svg";
export { ForwardRef as ReactComponent };